(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    /* =========================================================
   EGGWHITES PRODUCT GALLERY JAVASCRIPT
   ========================================================= */

(function () {

  'use strict';


  /* =======================================================
     SETTINGS
     ======================================================= */

  var DESKTOP_BREAKPOINT = 750;

  /*
   * Lower = softer / slower
   * Higher = faster / snappier
   */

  var SMOOTHNESS = 0.12;

  /*
   * Controls how much wheel movement becomes
   * gallery movement.
   */

  var WHEEL_MULTIPLIER = 0.35;


  /* =======================================================
     STATE
     ======================================================= */

  var scrollTarget = null;

  var animationFrame = null;


  /* =======================================================
     FIND GALLERY
     ======================================================= */

  function getRightGallery() {

    return document.querySelector(
      '.eggwhites-gallery-right'
    );

  }


  /* =======================================================
     SETUP GALLERY
     ======================================================= */

  function setupEggwhitesGallery() {

    if (
      window.innerWidth <
      DESKTOP_BREAKPOINT
    ) {

      return;

    }


    var galleries =
      document.querySelectorAll(
        'media-gallery.media-gallery--grid'
      );


    galleries.forEach(function (gallery) {

      var grid =
        gallery.querySelector(
          '.media-gallery__grid'
        );


      if (!grid) {

        return;

      }


      /*
       * Don't split the gallery twice.
       */

      if (
        grid.dataset.eggwhitesSplit === 'true'
      ) {

        return;

      }


      /*
       * Get product media.
       */

      var mediaItems =
        Array.from(
          grid.children
        ).filter(function (item) {

          return item.classList.contains(
            'product-media-container'
          );

        });


      /*
       * Need at least two images.
       */

      if (
        mediaItems.length < 2
      ) {

        return;

      }


      /* ===================================================
         CREATE LEFT COLUMN
         =================================================== */

      var leftColumn =
        document.createElement('div');

      leftColumn.className =
        'eggwhites-gallery-left';


      /* ===================================================
         CREATE RIGHT COLUMN
         =================================================== */

      var rightColumn =
        document.createElement('div');

      rightColumn.className =
        'eggwhites-gallery-right';


      /* ===================================================
         FIRST IMAGE → LEFT
         =================================================== */

      leftColumn.appendChild(
        mediaItems[0]
      );


      /* ===================================================
         REMAINING IMAGES → RIGHT
         =================================================== */

      mediaItems
        .slice(1)
        .forEach(function (item) {

          rightColumn.appendChild(
            item
          );

        });


      /* ===================================================
         SCROLL HINT
         =================================================== */

      var scrollHint =
        document.createElement('div');

      scrollHint.className =
        'eggwhites-scroll-hint';

      scrollHint.textContent =
        'SCROLL TO EXPLORE';


      rightColumn.appendChild(
        scrollHint
      );


      /* ===================================================
         CLEAR ORIGINAL GRID
         =================================================== */

      grid.innerHTML = '';


      /* ===================================================
         INSERT NEW COLUMNS
         =================================================== */

      grid.appendChild(
        leftColumn
      );

      grid.appendChild(
        rightColumn
      );


      /* ===================================================
         MARK AS CONVERTED
         =================================================== */

      grid.dataset.eggwhitesSplit =
        'true';


      /* ===================================================
         HIDE HINT AFTER SCROLL
         =================================================== */

      rightColumn.addEventListener(
        'scroll',
        function () {

          if (
            rightColumn.scrollTop > 10
          ) {

            rightColumn.classList.add(
              'eggwhites-has-scrolled'
            );

          }

        },
        {
          passive: true
        }
      );

    });

  }


  /* =======================================================
     SMOOTH ANIMATION
     ======================================================= */

  function animateGalleryScroll() {

    var gallery =
      getRightGallery();


    if (!gallery) {

      animationFrame = null;

      return;

    }


    if (
      scrollTarget === null
    ) {

      animationFrame = null;

      return;

    }


    var current =
      gallery.scrollTop;


    var difference =
      scrollTarget -
      current;


    /*
     * Stop when close enough.
     */

    if (
      Math.abs(difference) < 0.5
    ) {

      gallery.scrollTop =
        scrollTarget;

      animationFrame = null;

      return;

    }


    /*
     * Smooth ease toward target.
     */

    gallery.scrollTop =
      current +
      (
        difference *
        SMOOTHNESS
      );


    animationFrame =
      requestAnimationFrame(
        animateGalleryScroll
      );

  }


  /* =======================================================
     START ANIMATION
     ======================================================= */

  function startGalleryAnimation() {

    if (
      animationFrame
    ) {

      return;

    }


    animationFrame =
      requestAnimationFrame(
        animateGalleryScroll
      );

  }


  /* =======================================================
     WHEEL CONTROL
     IMAGE SCROLL FIRST → PAGE SCROLL AFTER IMAGE BOTTOM
     ======================================================= */

  var scrollTarget = null;
  var animationFrame = null;

  function getRightGallery() {
    return document.querySelector(
      '.eggwhites-gallery-right'
    );
  }

  function stopGalleryAnimation() {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  }

  function animateGalleryScroll() {
    var gallery = getRightGallery();

    if (!gallery || scrollTarget === null) {
      animationFrame = null;
      return;
    }

    var maxScroll = Math.max(
      0,
      gallery.scrollHeight - gallery.clientHeight
    );

    scrollTarget = Math.max(
      0,
      Math.min(maxScroll, scrollTarget)
    );

    var current = gallery.scrollTop;
    var difference = scrollTarget - current;

    if (Math.abs(difference) < 0.5) {
      gallery.scrollTop = scrollTarget;
      animationFrame = null;
      return;
    }

    gallery.scrollTop =
      current + difference * SMOOTHNESS;

    animationFrame = requestAnimationFrame(
      animateGalleryScroll
    );
  }

  function startGalleryAnimation() {
    if (!animationFrame) {
      animationFrame = requestAnimationFrame(
        animateGalleryScroll
      );
    }
  }

  document.addEventListener(
    'wheel',
    function (event) {

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        return;
      }

      var gallery = getRightGallery();

      if (!gallery) {
        return;
      }

      var rect = gallery.getBoundingClientRect();

      if (
        rect.bottom <= 0 ||
        rect.top >= window.innerHeight
      ) {
        scrollTarget = null;
        stopGalleryAnimation();
        return;
      }

      var maxScroll = Math.max(
        0,
        gallery.scrollHeight - gallery.clientHeight
      );

      if (maxScroll <= 1) {
        scrollTarget = null;
        return;
      }

      if (scrollTarget === null) {
        scrollTarget = gallery.scrollTop;
      }

      scrollTarget = Math.max(
        0,
        Math.min(maxScroll, scrollTarget)
      );

      var delta = event.deltaY;

      if (delta === 0) {
        return;
      }

      /* =====================================================
         SCROLL DOWN
         ===================================================== */

      if (delta > 0) {

        /*
         * Images are finished.
         * Do NOT preventDefault().
         * The normal page scroll takes over.
         */
        if (
          gallery.scrollTop >= maxScroll - 1 ||
          scrollTarget >= maxScroll - 1
        ) {

          gallery.scrollTop = maxScroll;
          scrollTarget = null;
          stopGalleryAnimation();

          return;
        }

        /*
         * Images still have room.
         * Consume the wheel event.
         */
        scrollTarget = Math.min(
          maxScroll,
          scrollTarget + delta * WHEEL_MULTIPLIER
        );

        event.preventDefault();
        startGalleryAnimation();

        return;
      }

      /* =====================================================
         SCROLL UP
         ===================================================== */

      if (delta < 0) {

        /*
         * Images are already at the top.
         * Let the normal page scroll take over.
         */
        if (
          gallery.scrollTop <= 1 ||
          scrollTarget <= 1
        ) {

          gallery.scrollTop = 0;
          scrollTarget = null;
          stopGalleryAnimation();

          return;
        }

        /*
         * Images still have room above.
         * Consume the wheel event.
         */
        scrollTarget = Math.max(
          0,
          scrollTarget + delta * WHEEL_MULTIPLIER
        );

        event.preventDefault();
        startGalleryAnimation();

        return;
      }

    },
    {
      passive: false
    }
  );

  /* =======================================================
     INITIAL LOAD
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        setupEggwhitesGallery();

      }
    );

  } else {

    setupEggwhitesGallery();

  }


  /* =======================================================
     SHOPIFY / HORIZON RE-RENDER PROTECTION
     ======================================================= */

  var observer =
    new MutationObserver(
      function () {

        setupEggwhitesGallery();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* =======================================================
     RESIZE
     ======================================================= */

  window.addEventListener(
    'resize',
    function () {

      if (
        window.innerWidth >=
        DESKTOP_BREAKPOINT
      ) {

        setupEggwhitesGallery();

      }

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
